import fitnessTraining1 from "../assets/home4.png";
import fitnessTraining2 from "../assets/home3.png";
import fitnessTraining3 from "../assets/home2.png";

// Home Swiper Images
import homeSwiperImh1 from "../assets/s1.jpg";
import homeSwiperImh2 from "../assets/s2.jpg";
import homeSwiperImh3 from "../assets/s3.jpg";

// Trainers Data Images
import trainer1 from "../assets/tr2.png";
import trainer2 from "../assets/tr1.png";
import trainer3 from "../assets/tr3.png";

// The Story Behind Our Gym imege
import story from "../assets/about5.png";

// allOurTrainersData Images
import ourTrainer1 from "../assets/home4.png";
import ourTrainer2 from "../assets/home2.png";
import ourTrainer3 from "../assets/home3.png";
import ourTrainer4 from "../assets/classes2.png";
import ourTrainer5 from "../assets/classes3.png";
import ourTrainer6 from "../assets/classes4.png";

import ourTrainers1 from "../assets/tr1.png";
import ourTrainers2 from "../assets/tr2.png";
import ourTrainers3 from "../assets/tr3.png";
import ourTrainers4 from "../assets/trainers2.png";
import ourTrainers5 from "../assets/trainers3.png";
import ourTrainers6 from "../assets/trainers4.png";

import blogArticle1 from "../assets/blog2.png";
import blogArticle2 from "../assets/blog3.png";
import blogArticle3 from "../assets/blog4.png";
import blogArticle4 from "../assets/blog5.png";
import blogArticle5 from "../assets/blog6.png";
import blogArticle6 from "../assets/blog7.png";

// Small Images
import thumbnail1 from "../assets/blog8.png";
import thumbnail2 from "../assets/blog9.png";
import thumbnail3 from "../assets/blog10.png";
import thumbnail4 from "../assets/blog11.png";
import thumbnail5 from "../assets/blog12.png";
import thumbnail6 from "../assets/blog13.png";

export const headerLinksData = [
  {
    id: 1,
    title: "Home",
    to: "/",
  },
  {
    id: 2,
    title: "About",
    to: "/about",
  },
  {
    id: 3,
    title: "Sessions",
    to: "/classes",
  },
  {
    id: 4,
    title: "Experts",
    to: "/trainers",
  },
  // {
  //   id: 5,
  //   title: "Blog",
  //   to: "/blog",
  // },
  {
    id: 6,
    title: "Contact",
    to: "/contact",
  },
];

export const fitnessTrainingData = [
  {
    id: 1,
    title: "Pilates Sessions",
    description:
      "Join our invigorating Pilates sessions designed to strengthen your core, improve flexibility, and enhance overall body alignment.",
    image: fitnessTraining1,
    to: "/yogaClass",
  },

  {
    id: 2,
    title: "Aerobic Sessions",
    description:
      "Experience the dynamic energy of our aerobic sessions, where upbeat music and expert guidance combine to create a fun and effective workout.",
    image: fitnessTraining2,
    to: "/",
  },

  {
    id: 3,
    title: "CrossFit Sessions",
    description:
      "Engage in our intense CrossFit sessions, blending strength training, conditioning, and high-intensity workouts to push your limits and achieve peak fitness.",
    image: fitnessTraining3,
    to: "/",
  },
];

export const homeSwiperData = [
  {
    id: 1,
    name: "Krena",
    title: "Accountant",
    image: homeSwiperImh1,
    description: `I transformed my fitness journey here. The trainers are dedicated, the atmosphere is motivating, and I've seen incredible results!`,
  },

  {
    id: 2,
    name: "Moyomi",
    title: "Student",
    image: homeSwiperImh2,
    description: `Joining Negi Fitness Club was the best decision I made for my health. The classes are challenging yet fun, and the community!`,
  },

  {
    id: 3,
    name: "Samira",
    title: "Engineer",
    image: homeSwiperImh3,
    description: `At NFC, the personalized workouts and nutrition guidance have helped me achieve my fitness goals faster than I ever imagined.`,
  },

  // {
  //   id: 4,
  //   name: "Nattasha",
  //   title: "Athletics /Trainer",
  //   image: homeSwiperImh1,
  //   description: `There are many variations of passages of Lorem Ipsum
  //                   available, but the majority have suffered alteration in some
  //                   form, by injected humour`,
  // },
];

export const trainersData = [
  {
    id: 1,
    nam: "Amanda",
    title: "Gain with our Personal Trainers",
    image: trainer1,
    to: "",
  },

  {
    id: 2,
    nam: "Madison Froning",
    title: "Nutrition and Wellness",
    image: trainer2,
    to: "",
  },

  {
    id: 3,
    nam: "Joshua Frankilin",
    title: "Sports Performance",
    image: trainer3,
    to: "",
  },
];

export const gymAmenitiesData = [
  {
    id: 1,
    title: "Modern Fitness Equipment",
    description:
      "Access top-of-the-line cardio machines, strength training equipment, and functional training gear to suit all fitness levels.",
  },
  {
    id: 2,
    title: "Group Exercise Classes",
    description: `Join invigorating group classes led by certified instructors, including yoga, Pilates, spinning, and more.`,
  },

  {
    id: 3,
    title: "Personal Training",
    description: `Work one-on-one with our expert trainers to achieve your fitness goals faster and more effectively.`,
  },

  {
    id: 4,
    title: "Locker Rooms",
    description:
      "Enjoy spacious and clean locker rooms equipped with showers, toiletries, and secure storage for your belongings.",
  },

  {
    id: 5,
    title: "Nutrition Guidance",
    description:
      "Receive personalized nutrition advice and meal planning support to complement your fitness regimen.",
  },

  {
    id: 6,
    title: "Social Areas",
    description: `Relax and connect with fellow members in our comfortable lounge areas, designed for post-workout socializing.`,
  },
];

export const ourPlansData = [
  {
    id: 1,
    title: "Basic",
    offer: "₹2900 / month",
    description: "30% Off for Beginners",
    icon: "fa-solid fa-heart",
    details: [
      "Access to gym facilities during regular hours.",
      "Group exercise classes included (limited selection).",
      "Personalized gym orientation session.",
      "Discounted rates on personal training sessions.",
    ],
    cta: "Get Started",
  },
  {
    id: 2,
    title: "Standard",
    offer: "₹4900 / month",
    description: "Most popular",
    icon: "fa-solid fa-star",
    details: [
      "All benefits of the Basic Plan.",
      "Expanded access to group exercise classes.",
      "Complimentary nutrition consultation.",
      "Access to premium locker room facilities.",
    ],
    cta: "Get Started",
  },
  {
    id: 3,
    title: "Premium",
    offer: "₹7900 / month",
    description: "10% Off for Yoga Class",
    icon: "fa-solid fa-gem",
    details: [
      "All benefits of the Standard Plan.",
      "Unlimited access to all group exercise classes.",
      "Priority booking for personal training sessions.",
      "Quarterly fitness assessments with personalized feedback.",
    ],
    cta: "Get Started",
  },
];

// Example of accessing plan details
const basicPlan = ourPlansData.find((plan) => plan.title === "Basic");
console.log(basicPlan);

export const articlesNewsData = [
  {
    id: 1,
    about: "Fitness",
  },

  {
    id: 2,
    about: "Health",
  },

  {
    id: 3,
    about: "Nutrition",
  },
];

export const gymStoryData = [
  {
    id: 1,
    welcome: "Welcome",
    title: "Story Behind Our Gym",
    description:
      "Our Journey Founded with a passion for health and wellness, Negi Fitness Club began as a small community gym. Our commitment to providing personalized fitness solutions and fostering a supportive environment has fueled our growth into a premier fitness destination.",
  },

  {
    id: 2,
    title: "The Purpose",
    image: story,
    description:
      "To transform lives through personalized fitness programs, cutting-edge facilities, and a vibrant community. ",
  },
  {
    id: 3,
    title: "Our Mission",
    description:
      "We strive to make fitness accessible, enjoyable, and effective for everyone.",
  },

  {
    id: 4,
    title: "Our Value",
    description:
      "We believe in creating a positive, encouraging atmosphere where everyone feels motivated to achieve their personal best",
  },
];

export const valuesBoxes = [
  {
    id: 1,
    icon: "fa-regular fa-newspaper",
    title: "Certified trainer",
    description:
      "Our trainers are certified professionals with extensive knowledge and skills.",
  },
  {
    id: 2,
    icon: "fa-solid fa-apple-whole",
    title: "Nutrition & diet",
    description:
      "Our comprehensive nutrition and diet plans are tailored to support and promote overall health.",
  },
  {
    id: 3,
    icon: "fa-solid fa-person",
    title: "Years of experience",
    description:
      "With 6 years of experience in the fitness industry, we have honed our expertise.",
  },
];

// Example of accessing a value box
const certifiedTrainerBox = valuesBoxes.find(
  (box) => box.title === "Certified trainer"
);
console.log(certifiedTrainerBox);

export const valuesNumbers = [
  {
    id: 1,
    number: "6+",
    description: "Year of Experience",
  },

  {
    id: 2,
    number: "350+",
    description: "Happy Clients",
  },

  {
    id: 3,
    number: "15+",
    description: "Expert Trainers",
  },

  {
    id: 4,
    number: "5k",
    description: "Instagram followers",
  },
];

export const allOurTrainersData = [
  {
    id: 1,
    title: "Pilates Training",
    image: ourTrainer1,
    description: "Build core strength and flexibility with expert guidance.",
    to: "/yogaClass",
  },
  {
    id: 2,
    title: "CrossFit",
    image: ourTrainer2,
    description: "High-intensity workouts to boost strength and endurance.",
    to: "/",
  },
  {
    id: 3,
    title: "Aerobic",
    image: ourTrainer3,
    description: "Fun, dynamic cardio sessions to improve fitness.",
    to: "/",
  },
  {
    id: 4,
    title: "Yoga As Therapy",
    image: ourTrainer4,
    description: "Therapeutic yoga for physical and mental well-being.",
    to: "/",
  },
  {
    id: 5,
    title: "Boxing",
    image: ourTrainer5,
    description: "Master boxing techniques for a full-body workout.",
    to: "/",
  },
  {
    id: 6,
    title: "Energy Dance",
    image: ourTrainer6,
    description: "Energizing dance classes for a fun fitness boost.",
    to: "/",
  },
];

export const ourTrainers = [
  {
    id: 1,
    image: ourTrainers1,
    name: "Rohan Negi",
    specializations: "CrossFit",
  },
  {
    id: 2,
    image: ourTrainers2,
    name: "Khaled Memon",
    specializations: "Boxing",
  },
  {
    id: 3,
    image: ourTrainers3,
    name: "Roshni Singh",
    specializations: "Yoga as Therapy",
  },
  {
    id: 4,
    image: ourTrainers4,
    name: "Aman Khanna",
    specializations: "Aerobic",
  },
  {
    id: 5,
    image: ourTrainers5,
    name: "Manvi Khattar",
    specializations: "Energy Dance",
  },
  {
    id: 6,
    image: ourTrainers6,
    name: "Mehar Chaudhary",
    specializations: "Pilates Training",
  },
];

export const blogArticlesNewsData = [
  {
    id: 1,
    title: "The 10 best exercises to do in your park",
    name: "Jacob Cornish",
    image: blogArticle1,
    thumbnail: thumbnail1,
  },
  {
    id: 2,
    title: "How to Choose The Right Equipment For You",
    name: "Benjamin Gray",
    image: blogArticle2,
    thumbnail: thumbnail2,
  },
  {
    id: 3,
    title: "How to Maximum Time Spent at the Gym",
    name: "David Ferguson",
    image: blogArticle3,
    thumbnail: thumbnail3,
  },

  {
    id: 4,
    title: "Simple Condition for all Around Fitness.",
    name: "William Wilkins",
    image: blogArticle4,
    thumbnail: thumbnail4,
  },

  {
    id: 5,
    title: "How to Modify any Program to Improve Your Weakness",
    name: "Benjamin Gray",
    image: blogArticle5,
    thumbnail: thumbnail5,
  },

  {
    id: 6,
    title: `The Beginner’s Guide to Weight Lifting`,
    name: "Bernadette",
    image: blogArticle6,
    thumbnail: thumbnail6,
  },
];

export const contactInfoData = [
  {
    id: 1,
    title: "Phone",
    icon: "fa-solid fa-phone",
    cta: "+91 87009 87633 ",
  },
  {
    id: 2,
    title: "Email",
    icon: "fa-solid fa-envelope",
    cta: "negirohan@nfc.in",
  },

  {
    id: 3,
    title: "Location",
    icon: "fa-solid fa-location-dot",
    cta: "C-12, Kumaun Complex, Dehradun, Uttarakhand, India",
  },
];
